// Libraries
import React, { useEffect, useState } from 'react'

// Styles
import { DropDownContainer } from './dropdown_styles'

// Components
import Button from '../../../global/button'
import Typography from '../../../global/typography'

// Helpers
import ImgUtil from '../../../../utils/img.utils'
import { internalLinkHandler } from '../../../../utils/link.utils'
import WrapperImage from '../../../global/wrapperImage'

type DropDownProps = {
  items: { text: string; externalUrl: string; internalLink: any }[]
  icon?: boolean
  isEvents: boolean
}

const DropDown = (props: DropDownProps) => {
  const [selectedItem, setSelectedItem] = useState(props.items?.[0]?.text || '')

  useEffect(() => {
    if (props.items) {
      props.items.find(item => {
        typeof window !== 'undefined' && urlIsMatch(item.externalUrl) && setSelectedItem(item.text)
      })
    }
  }, [])

  const handleAccordionOpen = (event: any) => {
    let current = event.currentTarget.classList.contains('is-active')
    const dropdownItems = document.querySelectorAll('.selection__dropdown-item-container')
    if (current) {
      event.currentTarget.classList.remove('is-active')
      if (dropdownItems[0]) dropdownItems[0].classList.remove('is-active')
    } else {
      let menuItems = document.querySelectorAll('.js-Menu-item')
      for (let item of menuItems) {
        if (item !== event.currentTarget) item.classList.remove('is-active')
      }
      event.currentTarget.classList.add('is-active')
      if (dropdownItems[0]) dropdownItems[0].classList.add('is-active')
    }
  }

  const urlIsMatch = (url: string) => {
    try {
      let convertedURL = url.indexOf('http') !== 0 ? new URL(url, location.origin) : new URL(url)
      return convertedURL.pathname === window.location.pathname
    } catch (err) {
      return false
    }
  }

  return (
    <DropDownContainer className="desktop--hide">
      <div className="selection__container">
        <div className="selection__dropdown-container">
          <button onClick={handleAccordionOpen} className="Menu-item js-Menu-item desktop--hide">
            <Typography className="selected__menu-item" type="label">
              {selectedItem}
            </Typography>
          </button>
          <div className="selection__dropdown-item-container">
            {props.items.map((item, index) => {
              const link = item.internalLink
                ? internalLinkHandler(item.internalLink)
                : item.externalUrl
              return (
                <Button
                  key={`Resource-Center_Dropdown-${index}`}
                  icon={false}
                  href={link}
                  text={item.text}
                  type="secondary"
                  size="medium"
                  theme="dark"
                  className={`ResourceCenter__Tab__BTNS ${
                    urlIsMatch(link) ? 'ResourceCenter__Tab__BTNS__active' : ''
                  }`}
                />
              )
            })}
          </div>
        </div>
        {props.icon && (
          <button className="filter__button" onClick={props.handleFilterButtonClick}>
            <WrapperImage
              className="filter__icon"
              src={
                props.isEvents
                  ? ImgUtil.getResizedImageUrl(
                      'https://images.ctfassets.net/5965pury2lcm/4mehQy1K2mWOjEitNgUrUF/3a7ac068be8daffdbe9b2941eef34f76/FilterButton-White.png',
                      ''
                    )
                  : ImgUtil.getResizedImageUrl(
                      'https://images.ctfassets.net/5965pury2lcm/4zQRnU1TwLcahG5dxnHB66/d5640aad4313beebc9642a2d467941bb/FilterButton-Black.png',
                      ''
                    )
              }
              alt="Filter icon"
              width={48}
              height={48}
              threshold={650}
            />
          </button>
        )}
      </div>
    </DropDownContainer>
  )
}

export default DropDown
